module.exports = __webpack_public_path__ + "static/media/Warning.b60bc9ad.svg";